import qs from 'qs'

import { HTTP } from './helpers/http.js'

export default {
  get(organizationId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    return HTTP.get(
      `/api/v1/organizations/${organizationId}/routine-definitions`,
      params
    )
  },
}
